const checkPathName = (term) => {
  return window.location.pathname.includes(term);
};

const getPageType = (nodeType) => {
  if (window.location.pathname === '/') {
    return 'home';
  }

  if (nodeType === 'product') {
    return 'product';
  }

  switch (true) {
    case checkPathName('/collections'):
      return 'category';
    case checkPathName('/c/'):
      return 'category';
    case checkPathName('/q/'):
      return 'search';
    case checkPathName('/checkout/cart'):
      return 'cart';
    case checkPathName('/checkout/checkout'):
      return 'checkout';
    case checkPathName('/checkout/finished'):
      return 'orderConfirmation';
    default:
      return 'other';
  }
};

class Nosto {
  constructor() {
    this.nostoJs = null;
  }

  nostoPageView(pageData) {
    switch (getPageType(pageData.node.pageFolderType)) {
      case 'home':
        this.triggerHomePageView();
        break;
      case 'product':
        this.triggerProductPageView(pageData);
        break;
      case 'other':
        this.triggerOtherView();
        break;
      default:
        break;
    }
  }

  async triggerHomePageView() {
    this.nostoJs = await this.getNostoJs();
    if (!this.nostoJs) return;
    this.nostoJs((api) => {
      api.defaultSession().viewFrontPage().load();
    });
  }

  async triggerProductPageView(pageData) {
    const productId = pageData?.data?.dataSources?.__master?.productId;
    this.nostoJs = await this.getNostoJs();
    if (!this.nostoJs || !productId) return;
    this.nostoJs((api) => {
      api.defaultSession().viewProduct(productId).load();
    });
  }

  async triggerOtherView() {
    this.nostoJs = await this.getNostoJs();
    if (!this.nostoJs) return;
    this.nostoJs((api) => {
      api.defaultSession().viewOther().load();
    });
  }

  getNostoJs() {
    return new Promise((resolve) => {
      if (window?.nostojs) {
        resolve(window?.nostojs);
      }

      const timeoutMs = 100;
      const maxWaitTimeMs = 10 * 1000;

      let count = 0;

      const intervalId = setInterval(() => {
        if (window?.nostojs) {
          resolve(window?.nostojs);
          clearInterval(intervalId);
        }

        count += 1;
        if (count * timeoutMs > maxWaitTimeMs) {
          console.warn('Nosto Session Id could not be accessed');
          resolve(null);
          clearInterval(intervalId);
        }
      }, timeoutMs);
    });
  }
}

// Path: apgdev/src/js/classes/Nosto.js
export default new Nosto();
